import { INK_FINDER_WIDGET_COOKIE_KEY } from 'b2b-apps/shop/catalog/redux/inkFinder/sagas';
import {
  InkFinderState,
  InkModelsType,
  IsInkWidgetOpenType,
} from 'b2b-apps/shop/catalog/redux/inkFinder/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { getCookie } from 'b2b-apps/shop/common/utils/storage/cookies';

const getState = (state: State): InkFinderState => state.catalog.inkFinder;

const getInkManufacturers = (
  state: State,
): RemoteRecord<InkModelsType> => new RemoteRecord(getState(state).manufacturers);

const getInkModels = (state: State): RemoteRecord<InkModelsType> => new RemoteRecord(getState(state).models);

const getIsInkWidgetOpen = (
  state: State,
): IsInkWidgetOpenType => (getState(state).isInkWidgetOpen === true || getState(state).isInkWidgetOpen === false)
  ? getState(state).isInkWidgetOpen
  : !!getCookie(INK_FINDER_WIDGET_COOKIE_KEY);

export {
  getInkManufacturers,
  getInkModels,
  getIsInkWidgetOpen,
  getState,
};
